import { createContext, ReactNode, useContext } from 'react';
import styles from './OverlayProvider.module.css';

type OverlayID = string | number;

interface OverlayProviderProps extends OverlayContextValue {
    children?: ReactNode;
}

interface OverlayProps {
    children?: ReactNode;
    id: OverlayID;
}

interface OverlayContextValue {
    open: OverlayID | null;
    opener: (id: OverlayID | null) => void;
}

function OverlayProvider({ children, open, opener }: OverlayProviderProps) {
    return <context.Provider value={{ open, opener }}>{children}</context.Provider>;
}

function Overlay({ id, children }: OverlayProps) {
    const context = useOverlay();
    const hidden = context.open !== id;

    return (
        <div className={styles.Overlay} hidden={hidden}>
            {children}
        </div>
    );
}

const context = createContext<OverlayContextValue>({
    open: null,
    opener: id => {
        throw new Error(`OverlayProvider not found when opening Overlay#${id}`);
    },
});

const useOverlay = () => useContext(context);

export default OverlayProvider;
export { Overlay, useOverlay };
export type { OverlayID, OverlayProviderProps, OverlayProps, OverlayContextValue };
